export default {
    offer: {
        save_hint: 'The print dialogue opens — choose "Save as PDF" as the destination.',
        invalid_title: 'This offer is not available',
        invalid_text: 'The offer link has expired or been replaced. Please contact the hotel.',
        eyebrow: 'Group offer',
        eyebrow_reservation: 'Your offer',
        nights: 'nights',
        financials: 'The offer',
        col_item: 'Item',
        col_quantity: 'Qty',
        col_price: 'Unit price',
        col_discount: 'Discount',
        col_vat: 'VAT',
        col_amount: 'Amount',
        total_net: 'Total excl. VAT',
        vat_at: 'VAT {rate} %',
        remaining: 'Balance due',
        rooms: 'Accommodation',
        per_night: 'night',
        up_to: 'up to {count} guests per room',
        total: 'Total',
        paid: 'Already paid',
        services: 'Hotel services',
        included: 'available to guests',
        valid_until: 'This offer is valid until {date}.',
        contact: 'Questions and confirmation',
        print: 'Print',
        save: 'Save PDF',
        confirm: 'Confirm the offer',
        confirmed_at: 'Offer confirmed on {date}. Thank you - the hotel has been notified.',
        units: { hour: 'hour', day: 'day', night: 'night', person: 'person', use: 'use', item: 'item', treatment: 'treatment' },
    },
    rooming: {
        pick: 'Choose…',
        invalid_title: 'This link is not valid',
        invalid_text: 'The guest-entry link has expired or been replaced. Please contact the hotel.',
        intro: 'Enter the guests of your group. The hotel will review the list and room them - an entry here is not yet a reservation.',
        add_title: 'Add a guest',
        first_name: 'First name',
        last_name: 'Last name',
        email: 'Email',
        phone: 'Phone',
        notes: 'Notes',
        add: 'Add',
        added: 'The guest was added to the list.',
        failed: 'The entry could not be saved.',
        entered: 'Entered guests ({count})',
        none_yet: 'No guests entered yet.',
        booking_title: 'Fellow travellers',
        rooms_title: 'Rooms',
        rooms_count: '{count} rooms',
        filled_of: '{filled} of {capacity} entered',
        pick_room_first: 'Choose a room above first.',
        adding_to: 'Adding to: {room}',
        unassigned: 'Unassigned',
        date_of_birth: 'Date of birth',
        nationality: 'Nationality',
        nationality_hint: 'e.g. SI',
        document_type: 'Document type',
        document_type_hint: 'e.g. passport',
        document_number: 'Document number',
        confirmed: 'Confirmed',
        booked_note: 'Guests already placed are confirmed by the hotel; please report any changes to reception.',
        register_hint: 'Date of birth, nationality and document are needed for the guest register required by law. Reception checks them on arrival.',
    },
    keys: {
        title: 'Keys',
        your_room: 'YOUR ROOM',
        your_pin: 'YOUR PIN',
        pin_text: 'Use your access code to enter all of your doors, or use the remote opening below.',
        your_keys: 'YOUR KEYS',
        door_room: 'Room',
        room_on_arrival: 'assigned on arrival',
        hold: 'Hold to unlock',
        unlocked: 'Unlocked',
        preview_note: 'Remote opening starts working once the hotel connects its locks — until then it is a preview.',
        demo_done: 'Preview — the locks are not connected yet.',
    },
    nav: {
        menu: 'Menu',
        roomservice_hint: 'Food and drinks straight to your room',
        roomservice: 'Room service',
        keys: 'Keys',
        short_keys: 'Keys',
        overview: 'Overview',
        checkin: 'Check-in',
        stay: 'My stay',
        arrival: 'Getting here',
        services: 'Services',
        payments: 'Payments & invoices',
        short_overview: 'Home',
        short_checkin: 'Check-in',
        short_arrival: 'Arrival',
        short_services: 'Services',
        short_payments: 'Bill',
        house: 'The hotel',
    },
    general: {
        back: 'Back',
        cancel: 'Cancel',
        close: 'Close',
        save_failed: 'Saving failed. Please try again.',
    },
    theme: {
        title: 'Light/dark theme',
        to_dark: 'Switch to dark theme',
        to_light: 'Switch to light theme',
    },
    overview: {
        eyebrow: 'YOUR UPCOMING STAY',
        language: 'Language',
        welcome: 'Welcome to',
        welcome_named: 'Welcome, {names}',
        and: 'and',
        subtitle: 'Arrange everything before you arrive, and during your stay.',
        arrival: 'ARRIVAL',
        departure: 'DEPARTURE',
        reservation: 'RESERVATION',
        ready: 'Ready for arrival',
        almost: 'Almost ready',
        all_done: 'All set',
        one_more_step: 'One more step',
        steps_left_two: '2 more steps',
        steps_left_few: '{n} more steps',
        step_profile: 'Personal details',
        step_document: 'Document',
        step_payment: 'Payment',
        finish_checkin: 'Finish check-in',
        card_checkin: 'Online check-in',
        card_checkin_text: 'Complete the guests\' details and shorten the front-desk stop.',
        card_checkin_go: 'Continue check-in',
        card_stay: 'My stay',
        card_stay_text: 'Room, arrival time, special requests and arrival directions.',
        card_stay_go: 'View reservation',
        card_services: 'Hotel services',
        card_services_text: 'Massage, sauna, dinner or bike hire.',
        card_services_go: 'Explore services',
        card_room_service: 'Room service',
        card_room_service_text: 'Food and drinks from the hotel kitchen, straight to your room.',
        card_room_service_go: 'See the menu',
        card_money: 'Charges & payments',
        card_money_go: 'Open your bill & payment',
        card_keys_title: 'Keys',
        card_keys_none: 'Your key and PIN are ready once a room is assigned at check-in.',
        card_keys_get: 'Get your key',
        card_keys_go: 'All keys and PIN',
        card_arrival: 'Getting here',
        card_arrival_text: 'Address, navigation and photos of the entrance, parking and garage.',
        card_arrival_go: 'View arrival directions',
        card_house: 'The hotel and nearby',
        card_house_text: 'Wi-Fi, opening hours, the welcome letter, prices and what is on in town.',
        card_house_go: 'Open hotel information',
        partly_paid: 'Partly paid',
        charges: 'Stay charges',
        parking_charges: 'Parking costs',
        paid: 'Paid',
        balance: 'Balance due',
    },
    checkin: {
        pick: 'Choose…',
        title: 'Online check-in',
        subtitle: 'Your details go securely straight to the hotel.',
        step_guests: 'Guests',
        step_documents: 'Documents',
        step_payment: 'Payment',
        step_confirm: 'Confirmation',
        guests_title: 'Guests on the reservation',
        unnamed: 'Unnamed guest',
        document_read: 'Document read · details complete',
        document_missing: 'Document missing',
        document_entered: 'Details entered · reception checks the document at arrival',
        done_badge: 'Done',
        add_document: 'Enter details',
        add_companion: 'Add companion',
        first_name: 'First name',
        last_name: 'Last name',
        companion_hint: 'Add a person staying with you. Their document goes in on the next step, same as your own.',
        companion_room: 'Room',
        companion_save: 'Add person',
        companion_saved: 'Added — now enter their document.',
        companion_incomplete: 'Enter the first and last name (and pick the room).',
        companion_failed: 'The person could not be added \u2014 the room may be full. Please contact reception.',
        wishes_title: 'Arrival & wishes',
        expected_arrival: 'Expected arrival',
        phone: 'Mobile number',
        phone_placeholder: '+386 41 234 567',
        wishes: 'Special requests',
        wishes_placeholder: 'Quiet room, higher floor',
        plate: 'Registration plate',
        plate_hint: 'If you will be parking a car in the car park or the garage.',

        // Marketing consent (docs/MARKETING.md §13). Never pre-ticked.
        consent_title:  'Offers by e-mail',
        consent_label:  "I would like to receive the hotel's offers and news by e-mail.",
        consent_hint:   'You can withdraw this at any time — including with one link at the foot of every letter. Messages about your booking arrive either way.',
        consent_failed: 'The consent could not be saved.',
        save_for_later: 'Save for later',
        continue_payment: 'Continue to payment',
        saved: 'Your check-in is saved.',
        doc_title: 'Add document',
        doc_type: 'Document type',
        doc_number: 'Document number',
        doc_nationality: 'Nationality',
        doc_nationality_hint: 'Two-letter country code, e.g. SI, DE, IT.',
        doc_birth: 'Date of birth',
        doc_save: 'Save details',
        doc_saved: 'The document is saved.',
        doc_incomplete: 'Fill in every field — the guest cannot be registered without them.',
        doc_hint: 'Read the document with the Imprion ID Scan app or enter the details by hand. The photo is not stored.',
        doc_manual: 'Manual entry',
        doc_idscan: 'Open ID Scan',
        doc_coming: 'Reading documents through the portal is coming soon — the front desk will read it until then.',
    },
    stay: {
        requests_title: 'YOUR REQUESTS',
        request_extension: 'Extension by {nights} nights',
        request_late_checkout: 'Late check-out',
        request_pending: 'waiting for reception',
        request_confirmed: 'confirmed',
        request_declined: 'not possible',
        title: 'My stay',
        room: 'Room',
        room_assigned_on_arrival: 'Your room will be assigned on arrival',
        occupancy: '{adults} adults · {children} children',
        expected: 'expected {hour}',
        late_checkout: 'Request late checkout',
        // Checking out and leaving the room are two events (docs/HOUSEKEEPING.md §16).
        room_released_title: 'Leaving the room',
        room_released_text: 'You are checked out, and we still have the room down as occupied. Once you tell us you have left it, we can go and prepare it for the next guest.',
        room_released: 'I have left the room',
        room_released_sent: 'Thank you - we have passed on that the room is free.',
        extension_check: 'Check a possible extension',
        extension_title: 'Extending the stay',
        extension_hint: 'See whether the nights after your departure are still free. The wish goes to reception, who confirm it — nothing books itself.',
        extension_same_room: 'Free — you can keep the same room',
        extension_other_room: 'Free — with a room change',
        extension_full: 'Sorry, no rooms are free for those nights.',
        extension_price: 'estimate {amount}/night on your rate',
        extension_request: 'Request +{nights}',
        extension_sent: 'Your extension request went to reception — they will come back to you.',
        late_checkout_sent: 'Your late-checkout request has been sent.',
        call: 'Call',
        status_booked: 'Booked',
        status_confirmed: 'Confirmed',
        status_checked_in: 'Checked in',
        status_checked_out: 'Checked out',
    },
    parking: {
        maps_card: 'Location and directions in Google Maps',
        card_title: 'Parking',
        card_title_both: 'Parking and garage',
        card_text: 'Enter your registration plate and the barrier opens automatically on arrival and during your stay.',
        add: 'Add registration plate',
        change: 'Change or add access',
        active_badge: 'Barrier armed',
        active_until: 'Automatic entry is active until {date}.',
        title: 'Automatic garage entry',
        hint: 'The camera at the barrier will recognise your plate during your stay and open automatically.',
        maps: 'Open in Google Maps',
        copy: 'Copy address',
        copied: 'Address copied.',
        plate: 'Vehicle registration plate',
        placeholder: 'e.g. MB AB-123',
        validity: 'Access validity',
        validity_range: '{from} to {to}',
        activate: 'Confirm and activate',
        activated: 'Plate {plate} is active for automatic entry.',
        check_plate: 'Please check the registration plate.',
        extra_cars: 'Additional vehicles',
        add_car: 'Add another car',
        remove_car: 'Remove',
        removed: 'The plate is removed; the barrier will no longer open for it.',
        removed_booking_kept: 'The plate is removed. The parking booking can no longer be cancelled through the portal — reception will handle it.',
        first_car_price: 'A parking space for the stay: {amount}. The amount goes on your stay bill.',
        included_note: 'Parking is included in the room rate.',
        remove_car_done: 'The booking for {plate} is cancelled and taken off the stay bill.',
        add_car_price: 'A parking space for the rest of the stay: {amount}. The amount goes on your stay bill.',
        add_car_book: 'Book and add to the bill',
        add_car_done: 'A parking space for {plate} is booked and on your stay bill.',
    },
    arrival: {
        title: 'Getting to the hotel',
        navigate: 'Navigate',
        back_to_stay: 'Back to my stay',
        entrance_title: 'Main entrance',
        entrance_text: 'A short stop for luggage and step-free access.',
        parking_title: 'Outdoor parking',
        parking_text: 'Enter with your own registration plate.',
        garage_title: 'Garage entrance',
        garage_text: 'The barrier opens automatically when the camera recognises your plate.',
    },
    services: {
        room_service_link: 'Room service',
        title: 'Services & experiences',
        subtitle: 'Services can be added straight to your stay bill.',
        loading: 'Loading the offer …',
        booked_title: 'ALREADY BOOKED',
        edit: 'Edit',
        edit_close: 'Close editing',
        edit_save: 'Confirm change',
        edit_hint: 'Pick the new days; one continuous span.',
        edit_gap: 'Pick consecutive days — for two separate spans make two bookings.',
        edited: 'The booking has been moved.',
        edit_failed: 'The change did not go through — the days may already be taken. Check the list.',
        desk_only_now: 'Changes or cancellation now only at the reception.',
        withdraw: 'Cancel',
        withdrawn: 'The booking is cancelled. Anything already charged has been reversed.',
        withdraw_failed: 'The cancellation did not go through — please contact the reception.',
        policy_until_start: 'Free cancellation through the portal until the start.',
        policy_hours: 'Free cancellation through the portal until {hours} h before the start.',
        policy_desk_only: 'Cancellation at the reception only.',
        quantity: 'How many',
        per_days: '/ {days} days',
        days_count: '{days} days',
        full_days: 'Full: {days}',
        plate_nth: 'Plate of car {number}',
        per_day: '/ day',
        stay_total: '{amount} for {nights} days',
        book: 'Book for your stay',
        full: 'Nothing left for your dates.',
        none: 'The hotel currently offers no services bookable through the portal. For appointments (massage, dinner) please contact the reception.',
        confirm_text: 'Booked for your whole stay, {from}–{to}. The amount of {amount} is added to your hotel bill.',
        confirm: 'Confirm booking',
        cancel: 'Cancel',
        needs_plate: 'Enter the vehicle registration plate.',
        booked: 'Booked. The service is on your stay bill.',
        book_failed: 'The booking did not go through — try again or contact the reception.',
        status_booked: 'booked',
        status_in_progress: 'in progress',
        status_completed: 'completed',
        status_cancelled: 'cancelled',
        status_no_show: 'not used',
    },
    room_service: {
        categories: 'Menu',
        my_orders: 'Your orders',
        basket_open: 'Basket',
        basket_title: 'Your order',
        when: 'Delivery time',
        when_asap: 'As soon as possible',
        when_today: 'Today at {time}',
        when_tomorrow: 'Tomorrow at {time}',
        closed_now_later: 'The kitchen is not serving right now — you can order for later.',
        ordered_at: 'ordered {when}',
        deliver_for: 'delivery {when}',
        ordered_for: 'Order received for {time} — {amount} on your room bill.',
        title: 'Room service',
        subtitle: 'Order from the hotel kitchen — the amount goes on your room bill.',
        loading: 'Loading the menu …',
        load_failed: 'The menu could not be loaded. Check your connection and try again.',
        retry: 'Try again',
        to_room: 'DELIVERY TO ROOM {room}',
        hours: 'Kitchen today: {hours}',
        shut_today: 'closed today',
        closed_now: 'The kitchen is not taking orders right now. Please try during its opening hours.',
        less: 'Remove one',
        more: 'Add one',
        empty_menu: 'The hotel has not added anything to the menu yet.',
        basket: 'YOUR ORDER',
        basket_empty: 'Use + to add food or drinks.',
        total: 'Total',
        note: 'Note for the kitchen',
        note_placeholder: 'e.g. no onion, two sets of cutlery',
        terms: 'When you confirm, the kitchen receives the order and the amount goes on your room bill, paid at check-out.',
        order: 'Order · {amount}',
        sending: 'Sending …',
        clear: 'Empty',
        orders: 'YOUR ORDERS',
        ordered: 'Order received — {amount} on your room bill.',
        retry_hint: 'No answer came back. Press Order again — the order will not be duplicated.',
        failed: 'The kitchen did not accept the order. Check it and try again, or call reception.',
        not_offered: 'The hotel does not offer room service through this portal. Please call reception to order.',
        not_in_house: 'Room service is available once you are checked in.',
        menu_unreadable: 'The menu cannot be read right now. Try again in a few minutes or call reception.',
    },
    stay_services: {
        per_appointment: '/ session',
        opens_at_checkin: 'Hotel appointments (massage, sauna …) and partner services nearby can be booked once you are checked in.',
        room: 'For which room',
        appointments: 'APPOINTMENTS AT THE HOTEL',
        loading_times: 'Checking free times …',
        times_failed: 'Free times could not be read. Please try again.',
        departed: 'Your stay has ended — new appointments can no longer be booked.',
        no_times: 'There are no free times before your departure.',
        departure_day: 'On your departure day only appointments ending by {time} are offered.',
        book: 'Book · {amount}',
        on_bill: 'on your room bill',
        booked: 'Appointment booked — {amount} on your room bill.',
        book_failed: 'The appointment could not be booked — it may have just been taken. Please choose again.',
        nearby: 'SERVICES NEARBY',
        minutes: '{minutes} min',
        partner_down: 'The partner is not responding right now. Try again in a few minutes or ask at reception.',
        no_times_day: 'The partner has no free times on this day.',
        partner_terms: 'We book the time with {partner}. Payment is as agreed with the hotel — on your room bill or at the partner.',
        nearby_done: 'Booked — they are expecting you.',
        taken: 'This time has just been taken at the partner. Please choose another.',
        nearby_booked: 'YOUR BOOKINGS WITH PARTNERS',
        cancel: 'Cancel',
        cancel_confirm: 'Confirm cancellation',
        cancel_changed: 'The cancellation cost has changed in the meantime.',
        cancel_unknown: 'The terms of {partner} may apply to a cancellation — ask reception about the cost or confirm the cancellation.',
        cancel_late: 'Late cancellation: the partner charges {amount} to your room.',
        cancel_late_free: 'The free cancellation period has passed, but the partner charges nothing for this service.',
        cancel_free: 'Cancellation is free until {deadline}.',
        cancel_gone: 'This booking can no longer be cancelled here. Please ask at reception.',
        cancelled: 'The booking is cancelled.',
        cancelled_fee: 'The booking is cancelled. The partner will charge {amount} to your room bill.',
        cancel_failed: 'The cancellation could not be made. Try again or ask at reception.',
    },
    order_pin: {
        title: 'Ordering PIN',
        hint: 'The hotel asks for your PIN before an order or a booking. You received it at check-in from reception or by e-mail.',
        label: 'PIN',
        confirm: 'Confirm',
        wrong: 'That PIN is not right. Please try again.',
        locked: 'Too many wrong attempts. Try again in a few minutes or ask at reception.',
    },
    payment_done: {
        paid_title: 'Payment successful',
        paid_text: 'Thank you! The payment went through — the reception will see it booked within seconds.',
        cancelled_title: 'Payment not made',
        cancelled_text: 'Nothing was charged. Ask the reception for a new attempt.',
    },
    payments: {
        details_open: 'View order',
        details_total: 'Total',
        details_tax: 'incl. VAT {rate} %: {amount}',
        title: 'Payments & invoices',
        reservation: 'Reservation {number}',
        open_badge: 'Open',
        folio_title: 'Stay bill',
        due: 'Balance due',
        pay_starting: 'Opening payment …',
        pay_failed: 'The payment could not be started — try again or contact the reception.',
        paid_message: 'Payment received. Thank you!',
        method_cash: 'cash',
        method_card: 'card',
        method_transfer: 'bank transfer',
        method_voucher: 'voucher',
        method_prepayment: 'prepayment',
        method_ota_virtual_card: 'virtual card',
        processing_title: 'Payment being processed',
        processing_text: 'Waiting for the payment provider\'s confirmation. This usually takes a few seconds — the page will tell you when the payment is booked.',
        processing_timeout: 'No confirmation yet. If the payment went through it will appear among the lines shortly — otherwise contact the reception.',
        overpaid_message: 'The amount paid is more than what was due — the reception will settle the difference as credit.',
        cancelled_message: 'The payment was cancelled.',
        settled_badge: 'Settled',
        stripe_note: 'The card is entered on Stripe\'s secure page; the hotel never sees or stores card details. Test environment.',
        pay_now: 'Pay now',
        proforma: 'Download proforma',
        proforma_failed: 'The pro forma could not be prepared — please try again.',
        invoices: 'Invoices',
        invoices_text: 'The final invoice will be available after your stay.',
        documents: 'Documents',
        no_invoice_yet: 'The final invoice has not been issued yet.',
        secure_title: 'Secure payment',
        secure_text: 'Neither the hotel nor Imprion stores your card details.',
        pay_title: 'Payment {amount}',
        simulated: 'Simulated payment — your card will not be charged.',
        simulated_done: 'That was a simulation — online payment arrives in a coming release.',
        cardholder: 'Cardholder',
        card_number: 'Card number',
        expiry_cvc: 'Expiry / CVC',
        pay_secure: 'Pay securely',
    },
    studio: {
        button: 'Customise portal',
        title: 'Hotel portal customisation',
        hint: 'A preview for styling an individual property. Imprion Guest remains named as the portal provider.',
        primary: 'Primary colour',
        accent: 'Accent colour',
        compact: 'squarer elements',
        preview_only: 'Preview only — the hotel look is saved by the reception.',
    },
    license: {
        eyebrow: 'Online check-in',
        title: 'This service is not enabled',
        lead: 'This hotel has not enabled online check-in, so this portal cannot be opened. Your reservation is unaffected.',
        another_link: 'If you have since been sent a different link, simply open it — this page will load afresh.',
        contact: 'For anything about your stay, please contact the hotel’s front desk — they will be glad to help.',
    },
    memory: {
        eyebrow: 'A memory of your stay',
        thanks: 'Thank you for visiting',
        lead: 'It was a pleasure to have you. Here is a short memory of your stay.',
        stayed: 'Stay',
        room: 'Room',
        used: 'What you used',
        nights: 'Nights',
        nights_one: '{n} night',
        nights_two: '{n} nights',
        nights_few: '{n} nights',
        nights_many: '{n} nights',
        guests: 'Guests',
        guests_one: '{n} guest',
        guests_two: '{n} guests',
        guests_few: '{n} guests',
        guests_many: '{n} guests',
        book_again: 'Book again',
        invoice: 'Send me the invoice by e-mail',
        invoice_sending: 'Sending…',
        invoice_sent: 'The invoice has been sent to the e-mail address you gave us.',
        invoice_failed: 'The invoice could not be sent just now. Please try later or write to the hotel.',
        privacy: 'This page stays open and carries no personal data.',
    },
    invalid: {
        demo_opening: 'Opening the stay …',
        hotel_fallback: 'Your hotel',
        reception: 'Front desk',
        eyebrow: 'Need a new link?',
        title: 'No worries — we can sort that out quickly',
        text: 'For your security, this link is no longer active. Your reservation has not been cancelled and no information was lost.',
        help_title: 'What to do next',
        step_contact_title: 'Contact the front desk',
        step_contact_text: 'Call the hotel or send them a short message.',
        step_identify_title: 'Tell them which stay it is',
        step_identify_text: 'Your name and expected arrival date are enough.',
        step_open_title: 'Open the new link',
        step_open_text: 'The hotel will send it by email or message.',
        retry: 'Try again',
        security: 'Links expire to help protect the details of your stay.',
    },
    /*
     * The house — the room televisions' content on a phone (docs/DISPLAY.md §9).
     *
     * Its own namespace because this is the BUILDING and not the stay: every guest in
     * the house reads the same words, whatever their booking says. The vocabulary is
     * deliberately the screens' own (`house.*`, `local.kind_*` in pms-display), so the
     * hotel does not speak two languages on the wall and on the telephone.
     */
    house: {
        sign_up: 'Sign us up',
        signed_up: 'Signed up',
        signup_count: '{count} signed up',
        guest_deal: 'Hotel guests: {deal}',
        voucher_title: 'Your guest voucher',
        voucher_open: 'Open the voucher',
        voucher_note: 'Show the QR or open the link at the partner — the page confirms live that you are a guest of the hotel.',
        locked_eye: 'Unlocks at check-in',
        locked_text: 'The hotel pages — Wi-Fi, the welcome letter, the programme and the surroundings — unlock on your phone when you check in. See you at reception!',
        title: 'The hotel',
        loading: 'Loading …',
        failed: 'The hotel information cannot be shown right now. Please try again in a moment.',
        section_house: 'WELCOME',
        section_letter: 'WELCOME LETTER',
        section_today: 'TODAY IN THE HOTEL',
        section_weather: 'WEATHER',
        section_services: 'SERVICES AND PRICES',
        section_events: 'EVENTS NEARBY',
        section_places: 'PLACES NEARBY',
        wifi: 'Wi-Fi',
        network: 'Network',
        password: 'Password',
        wifi_open: 'The network is open — no password needed.',
        hours: 'Opening hours',
        phone_keys: 'Telephone keys',
        room_phone: 'From the telephone in your room.',
        emergency: 'Emergency',
        per_day: '/ day',
        per_item: '/ once',
        to_services: 'Book a service',
        open_in_maps: 'Open in Google Maps',
        kind_sight: 'Sight',
        kind_restaurant: 'Where to eat',
        kind_activity: 'Activity',
        kind_shop: 'Shopping',
        kind_other: 'Nearby',
    },
    /* The forecast is Open-Meteo; `weather` is a token for the sky, translated here. */
    weather: {
        today: 'today',
        rain_chance: '{percent} %',
        clear: 'clear',
        partly_cloudy: 'partly cloudy',
        overcast: 'overcast',
        fog: 'fog',
        drizzle: 'drizzle',
        rain: 'rain',
        rain_showers: 'showers',
        snow: 'snow',
        snow_showers: 'snow showers',
        thunderstorm: 'thunderstorm',
    },
    /*
     * Milo, the house's assistant in the guest's own hands.
     *
     * Short sentences on purpose: this is read on a telephone, standing up, usually with
     * one hand. `executed` says "handed over" and never "done" — every one of the four
     * actions is a REQUEST the hotel then acts on, and a portal that said "done" would
     * be promising on the hotel's behalf.
     *
     * `result.*` is what a confirmed proposal DID, keyed by the outcome code the service
     * sends. The Slovenian 1/2/3-4/5+ forms are chosen in `libs/chatResult.ts` and not by
     * vue-i18n, for the reason written there; the other languages carry the same four
     * keys so that the two locale files never disagree about which keys exist.
     */
    milo: {
        title: 'Milo',
        greeting: 'Hello, I am Milo.',
        intro: 'Ask me about the hotel and about your stay — I answer in your language.',
        placeholder: 'Write your question …',
        send: 'Send',
        thinking: 'Milo is thinking …',
        still_working: 'Still looking — this can take a minute.',
        disclaimer: 'Milo is the hotel assistant. He takes no payments and issues no invoices; for everything else the reception is there.',
        open: 'Open Milo',
        close: 'Close',
        chip_wifi: 'Wi-Fi',
        chip_wifi_text: 'What is the Wi-Fi password?',
        chip_breakfast: 'Breakfast',
        chip_breakfast_text: 'Until when is breakfast served?',
        chip_late_checkout: 'Late checkout',
        chip_late_checkout_text: 'Could I stay in the room a little longer?',
        chip_today: 'What is on today',
        chip_today_text: 'What is happening nearby today?',
        confirm: 'Confirm',
        decline: 'No, not now',
        executed: 'Sent',
        declined: 'Not sent.',
        failed: 'That did not work. Try again, or call the reception.',
        expired: 'This proposal has expired. Please ask again.',
        already_decided: 'This proposal has already been decided.',
        card_closed: 'This proposal can no longer be confirmed.',
        budget_spent: 'That is enough questions for today. Try again tomorrow, or call the reception.',
        throttled: 'One moment — try again in a few seconds.',
        too_long: 'Milo took too long for this question. Ask something more specific, or call the reception.',
        interrupted: 'Milo was interrupted while answering. Please ask once more.',
        unavailable: 'Milo is not available right now. The reception will help you.',
        result: {
            late_checkout_requested:    'Your late checkout request is with the reception.',
            guest_service_booked_one:   'Booked for {count} day.',
            guest_service_booked_two:   'Booked for {count} days.',
            guest_service_booked_few:   'Booked for {count} days.',
            guest_service_booked_other: 'Booked for {count} days.',
            room_request_raised:        'Your request is with housekeeping.',
            reception_message_sent:     'Your message is with the reception.',
            room_service_ordered_one:   'The kitchen has your order: {count} item, {detail}.',
            room_service_ordered_two:   'The kitchen has your order: {count} items, {detail}.',
            room_service_ordered_few:   'The kitchen has your order: {count} items, {detail}.',
            room_service_ordered_other: 'The kitchen has your order: {count} items, {detail}.',
            lost_item_reported:         'Your report is filed under {detail}; reception will let you know.',
            transfer_requested:         'Your transfer request ({detail}) is with reception.',
        },
    },
}
